import React from 'react';
import logoImage from '../assets/logo.png'; // Uncomment this line when you have added your logo image

const Logo = () => {
  return (
    <div className="logo-container" style={{ display: 'flex', alignItems: 'center' }}>
      {/* 
        INSTRUCTIONS:
        1. Place your logo image (e.g., logo.png) in the 'src/assets' folder.
        2. Uncomment the import line above.
        3. Uncomment the <img /> block below and remove the existing SVG/text code.
      */}
      

      <img 
        src={logoImage} 
        alt="Faith Connect Logo" 
        style={{ 
          height: '40px', 
          width: 'auto' 
        }} 
      /> 
    </div>
  );
};

export default Logo;
